import { palette } from "@src/core/styles";
import styled from "styled-components";

export const CheckBoxContainer = styled.div`
  width: 100%;

  & .MuiFormControlLabel-root {
    margin-left: 0;
  }
  & .MuiCheckbox-colorPrimary.Mui-checked {
    color: ${palette.colors.green_base};
  }
  & .MuiButtonBase-root-MuiCheckbox-root:hover {
    background: none;
  }
  & span {
    padding: 0;
    margin-right: 4px;
  }
`;
